/** Módulo en Storage: instalaciones/study-download-center-bridge */
export const STUDY_DOWNLOAD_BRIDGE_MODULE_ID = "study-download-center-bridge" as const;

/** Endpoints del bridge (study-download-center-bridge / study-pacs-bridge). */
export const BRIDGE_ENDPOINTS = [
  "/api/v1/bridge/center",
  "/api/v1/bridge/studies",
  "/api/v1/bridge/studies/*/instances",
  "/api/v1/bridge/studies/*/series/*/instances/*",
  "/api/v1/bridge/exports",
] as const;

/** Endpoints del router Go v2 (licencia, storage, inventario, cola). */
export const ROUTER_ENDPOINTS = [
  "/api/v1/license/requests",
  "/api/v1/license/install",
  "/api/v1/storage/resumable-uploads",
  "/api/v1/infra/sync",
  "/api/v2/queue/study",
  "/api/v2/solvent",
] as const;

/** Endpoints para HIS (reportes médicos, proxies de IA, notificaciones). */
export const HIS_ENDPOINTS = [
  "/api/v1/medical/report/anonymous",
  "/api/v1/medical/report/patient-orders",
  "/api/v1/medical/report/*/owner",
  "/api/v1/ai-generic/generate-sync",
  "/api/v1/ai-generic/generate-async",
  "/api/v1/ai-generic/jobs/*",
  "/api/sendgrid/send-email",
] as const;

/** Endpoints para RIS (worklist stream/orders, consultas de imágenes, reportes y lab). */
export const RIS_ENDPOINTS = [
  "/api/v1/worklist/stream",
  "/api/v1/worklist/orders",
  "/api/v1/worklist/orders/*",
  "/api/imaging/query",
  "/api/imaging/open/report/*/*",
  "/api/lab/upload",
  "/api/lab/process",
] as const;

/** Endpoints para Visor OHIF (tokens de visualización). */
export const VISOR_ENDPOINTS = [
  "/api/viewer/token/*",
] as const;

/** Endpoints recomendados al crear API Key para instalaciones on-premise. */
export const DEFAULT_INSTALLATION_API_KEY_ENDPOINTS = [
  ...BRIDGE_ENDPOINTS,
  ...ROUTER_ENDPOINTS,
  ...HIS_ENDPOINTS,
  ...RIS_ENDPOINTS,
  ...VISOR_ENDPOINTS,
] as const;

export function endpointsForModules(modules: readonly string[]): string[] {
  const set = new Set<string>();
  if (
    modules.includes(STUDY_DOWNLOAD_BRIDGE_MODULE_ID) ||
    modules.includes("pacs")
  ) {
    for (const e of BRIDGE_ENDPOINTS) set.add(e);
  }
  if (modules.includes("router")) {
    for (const e of ROUTER_ENDPOINTS) set.add(e);
  }
  if (modules.includes("his")) {
    for (const e of HIS_ENDPOINTS) set.add(e);
  }
  if (modules.includes("ris")) {
    for (const e of RIS_ENDPOINTS) set.add(e);
  }
  if (modules.includes("visor")) {
    for (const e of VISOR_ENDPOINTS) set.add(e);
  }
  return [...set];
}
